export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const IMG_API_KEY = "80f906a0859603565f4da17d8613197f";
export const IMG_END_POINT = `https://api.imgbb.com/1/upload?key=${IMG_API_KEY}`